import React, { useEffect, useState } from "react";
import { Table } from "antd";
import getSupportColumns from "../../../const/Columns/getSupportColumns";
import { deleteSupportServer, getAllTickets } from "../../../apis/supportApi";
import { Link } from "react-router-dom";

const Support = () => {
  const [support, setSupport] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [filteredList, setFilteredList] = useState([]);

  useEffect(() => {
    fetchSupport();
  }, []);

  useEffect(() => {
    if (support?.length > 0) {
      const filtered = support?.filter(
        (ticket) =>
          ticket.name?.toLowerCase().includes(searchText.toLowerCase()) ||
          ticket.email?.toLowerCase().includes(searchText.toLowerCase()),
      );
      setFilteredList(filtered);
    }
  }, [searchText, support]);

  const fetchSupport = async () => {
    try {
      const res = await getAllTickets();
      setSupport(res.result);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const deleteSupport = async (id) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this Support?",
    );
    if (isConfirmed) {
      setLoading(true);
      await deleteSupportServer(id);
      fetchSupport();
    }
  };

  const columns = getSupportColumns(deleteSupport);
  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="d-flex  justify-content-between  align-items-center">
              <Link to="/addSupport" className="btn add-new btn-primary mb-3">
                Add Ticket
              </Link>

              <input
                type="text"
                placeholder="Search by title"
                className="form-control w-25"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className="table-respoinsive">
                <Table
                  columns={columns}
                  dataSource={
                    searchText && filteredList?.length > 0
                      ? filteredList
                      : support?.length > 0
                        ? support
                        : []
                  }
                  className="table-striped "
                  rowKey={(record) => record.id}
                  // scroll={{ y: 400 }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Support;
